import React from "react";
import "./App.css";
import ResumePage from './pages/Resume'

function App() {
  return (
    <div className="App">
      <ResumePage/>
    </div>
  );
}

export default App;
